import * as Schema from "effect/Schema";
/** All serialized domain values are decoded by these Effect 4 schemas. */
export const Finite = Schema.Number.check(Schema.isFinite());
export const NonNegative = Finite.check(Schema.isGreaterThanOrEqualTo(0));
export const Positive = Finite.check(Schema.isGreaterThan(0));
export const SafeInteger = Schema.Int.check(Schema.isGreaterThanOrEqualTo(0), Schema.isLessThanOrEqualTo(Number.MAX_SAFE_INTEGER));
export const Revision = SafeInteger;
export const TimeMs = NonNegative.check(Schema.isLessThanOrEqualTo(Number.MAX_SAFE_INTEGER));
export const IntegerTimeMs = SafeInteger;
export const Identifier = Schema.String.check(Schema.isPattern(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/));
export const ContentHash = Schema.String.check(Schema.isPattern(/^[a-f0-9]{64}$/));
export const NonEmptyText = Schema.String.check(Schema.isMinLength(1));
export const HexColor = Schema.String.check(Schema.isPattern(/^#[a-fA-F0-9]{6}$/));
export const UnitInterval = Finite.check(Schema.isGreaterThanOrEqualTo(0), Schema.isLessThanOrEqualTo(1));
export const Dimensions = Schema.Struct({
    width: SafeInteger.check(Schema.isGreaterThan(0), Schema.isLessThanOrEqualTo(16384)),
    height: SafeInteger.check(Schema.isGreaterThan(0), Schema.isLessThanOrEqualTo(16384)),
});
export const Point = Schema.Struct({ x: Finite, y: Finite });
export const NormalizedPoint = Schema.Struct({ x: UnitInterval, y: UnitInterval });
export const Rect = Schema.Struct({ x: NonNegative, y: NonNegative, width: Positive, height: Positive });
export const NormalizedRect = Rect.check(Schema.makeFilter((r) => r.x + r.width <= 1 && r.y + r.height <= 1 || "rectangle must fit within normalized asset bounds"));
export const TimeRange = Schema.Struct({ startMs: TimeMs, endMs: TimeMs }).check(Schema.makeFilter((range) => range.endMs > range.startMs || "endMs must be greater than startMs"));
export const hasUniqueIds = (items) => new Set(items.map((item) => item.id)).size === items.length;
export const rectFits = (rect, size) => rect.x + rect.width <= size.width && rect.y + rect.height <= size.height;
/** Freeze metadata only: binary buffers have separate ownership and are never frozen here. */
export function freezeMetadata(value) {
    if (value !== null && typeof value === "object" && !Object.isFrozen(value)) {
        if (ArrayBuffer.isView(value) || value instanceof ArrayBuffer) {
            throw new TypeError("Binary data cannot be included in metadata snapshots");
        }
        for (const child of Object.values(value))
            freezeMetadata(child);
        Object.freeze(value);
    }
    return value;
}
export class ValidationError extends Schema.TaggedError()("ValidationError", {
    message: Schema.String,
    path: Schema.String,
}) {
}
export class RevisionConflict extends Schema.TaggedError()("RevisionConflict", {
    expected: Revision,
    actual: Revision,
}) {
}
